import { fa2en } from "@/utils/helpers/inputFormatter";
import {ref} from "vue";

export const requiredRule = (v: string) =>
  !!v || `پر کردن این فیلد اجباری است.`;

export const requiredRuleCrmLinkUser = (v: string) =>
  !!v || `پر کردن این فیلد اجباری است.`;

export const requiredRuleSelect = (v: string | number) =>
  !!v || `انتخاب یک مورد اجباری است.`;

export const requiredRuleAutoComplete = (v: any) => {
  v.length !== 0 || `انتخاب یک مورد اجباری است.`;
};

export const length = (length: number) => (v: string) => {
  if (!v) return true;
  return v.length == length || `${length} کاراکتر وارد کنید.`;
};

export const minLength = (length: number) => (v: string) => {
  if (!v) return true;
  return v.length >= length || `حداقل ${length} کاراکتر وارد کنید.`;
};

export const maxLength = (length: number) => (v: string) => {
  if (!v) return true;
  return v.length <= length || `حداکثر ${length} کاراکتر وارد کنید.`;
};

export const max = (length: number) => (v: string) => {
  if (!v) return true;
  const enNumber = fa2en(v);
  return enNumber <= length || `مقدار وارد شده نمیتواند بیشتر از  ${length} باشد.`;
};

export const confirmRule = (confirm: string) => (v: string) => {
  if (!v) return true;
  return v === confirm || "مقدار وارد شده با تکرار آن برابر نیست.";
};

export const noSpecial = (v: string) => {
  if (!v) return true;
  return (
    /[^@#$%^&*()_+/.<ء":{}×!>أ،:؛\]\[']+$/.test(v) ||
    "مقدار وارد شده معتبر نیست"
  );
};

export const lowercase_and_int = (v: string) => {
  if (!v) return true;
  return (
    /^(?=.*?\d)(?=.*?[a-z])[a-z\d]+$/.test(v) || "مقدار وارد شده معتبر نیست"
  );
};

export const alphabet = (v: string) => {
  if (!v) return true;
  return /^[a-zA-Z]+$/.test(v) || "مقدار وارد شده معتبر نیست";
};

export const valid_character = (v: string) => {
  if (!v) return true;
  return /^[a-zA-Z0-9_.-]*$/.test(v) || "مقدار وارد شده معتبر نیست";
};

export const email = (v: string) => {
  if (!v) return true;
  return (
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(
      v
    ) || "ایمیل وارد شده معتبر نیست"
  );
};

export const url = (v: string) => {
  if (!v) return true;
  return (
    /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/.test(
      v
    ) || "مقدار وارد شده معتبر نیست"
  );
};

export const integer = (v: string) => {
  if (!v) return true;
  const enNumber = fa2en(v);
  return /^[۰۱۲۳۴۵۶۷۸۹0-9٬]+$/.test(enNumber) || "مقدار وارد شده معتبر نیست";
};

export const floatNumber = (v: string) => {
  if (!v) return true;
  return /^-?\d+(\.\d+)?$/.test(v) || "مقدار وارد شده معتبر نیست";
};

export const mobile = (v: string) => {
  if (!v) return true;
  const enNumber = fa2en(v);
  return (
    /^(?:\+989|989|09|9)\d{9}$/.test(enNumber) || "مقدار وارد شده معتبر نیست"
  );
};

export const phone = (v: string) => {
  if (!v) return true;
  const enNumber = fa2en(v);
  return (
    mobile(v) === true ||
    homePhone(enNumber) === true ||
    "مقدار وارد شده معتبر نیست"
  );
};

export const homePhone = (v: string) => {
  if (!v) return true;
  return (
    /^(?:98|0)(41|45|31|84|77|21|38|51|56|58|61|24|23|54|71|26|25|28|87|34|83|74|17|13|66|11|86|76|81|35)\d{8}$/.test(
      v
    ) || "مقدار وارد شده معتبر نیست"
  );
};

export const iranianPhone = (v: string) => {
  if (!v) return true;
  const enNumber = fa2en(v);
  return /^(?:\+98|98|0|)\d{10}$/.test(enNumber) || "مقدار وارد شده معتبر نیست";
};

export const iranianPhone98 = (v: string) => {
  if (!v) return;
  const enNumber = fa2en(v);
  return /^(?:98)\d{10}$/.test(enNumber) || "مقدار وارد شده معتبر نیست";
};

export const postalCode = (v: string) => {
  if (!v) return true;
  const enNumber = fa2en(v);
  return /^[13456789]{10}$/.test(enNumber) || "مقدار وارد شده معتبر نیست";
};

export const nationalCode = (v: string) => {
  if (!v) return true;
  if (v && v != "0000000000") {
    const isValid = /^[۰۱۲۳۴۵۶۷۸۹0-9]{10}$/.test(v);
    if (isValid) {
      const enCode = fa2en(v);
      const check = +enCode[9];
      const sum =
        Array(9)
          .fill()
          .map((_, i) => +enCode[i] * (10 - i))
          .reduce((x, y) => x + y) % 11;
      return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
    } else {
      return "مقدار وارد شده معتبر نیست";
    }
  }
};

export const nationalId = (v: string) => {
  if (!v) return true;
  const isValid = /^[۰۱۲۳۴۵۶۷۸۹0-9]{11}$/.test(v);
  if (isValid) {
    const enCode = fa2en(v);
    if (parseInt(enCode.substr(3, 6), 10) == 0) return false;
    let c = parseInt(enCode.substr(10, 1), 10);
    let d = parseInt(enCode.substr(9, 1), 10) + 2;
    let z = new Array(29, 27, 23, 19, 17);
    let s = 0;
    for (let i = 0; i < 10; i++)
      s += (d + parseInt(enCode.substr(i, 1), 10)) * z[i % 5];
    s = s % 11;
    if (s == 10) s = 0;
    return c == s;
  } else {
    return "مقدار وارد شده معتبر نیست";
  }
};

export const crmUrl = (v: string) => {
  if (!v) return true;
  return (
    /^(https?:\/\/)?((\d{1,3}\.){3}\d{1,3}|[a-zA-Z0-9\-\.]+)(:[a-zA-Z0-9]+)?(\/[^\s]*)?$/.test(v) ||
    "مقدار وارد شده معتبر نیست"
  );
};

export const enNumberRules = (v: number) => {
  if (v === null || v === undefined) return true;
  const strValue = String(v);
  return /^[0-9]*$/.test(strValue) || "تنها اعداد انگلیسی مجاز می‌باشد.";
};

